import script from "./StartedDayPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./StartedDayPopup.vue?vue&type=script&setup=true&lang=js"

import "./StartedDayPopup.vue?vue&type=style&index=0&id=5e1edbb6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e1edbb6"]])

export default __exports__